import { PerspectiveCamera } from '@react-three/drei';
import { LANDING_CAMERA } from '../../constants/camera';

export default function CameraRig() {
  return (
    <PerspectiveCamera
      makeDefault
      fov={LANDING_CAMERA.fov}
      near={LANDING_CAMERA.near}
      far={LANDING_CAMERA.far}
      position={LANDING_CAMERA.position}
    />
  );
}
